import { decryptText } from './decryptText'

export const decryptSelfConstructToken = (cipherText) => {
  return decryptText({ type: 'selfConstructedBooking', cipherText })
}
